import { authFetch } from './authFetch';
import { API_BASE } from './version';
import type { InsightsResponse, InsightsRange } from '../../../../shared/lib/insights';

/** GET /api/v1/insights — Forge Wrapped stats for the active account. */
export async function fetchInsights(range: InsightsRange): Promise<InsightsResponse> {
  const qs = range === 'all' ? '' : `?since=${range}`;
  const response = await authFetch(`${API_BASE}/insights${qs}`, { method: 'GET' });
  if (!response.ok) throw new Error(`Failed to fetch insights: ${response.statusText}`);
  const body = (await response.json()) as { data: InsightsResponse };
  return body.data;
}
